import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// third-party
import _ from 'lodash';

import { openSnackbar } from 'store/reducers/snackbar';

import useAuth from 'hooks/useAuth';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloudDownloadOutlined } from '@ant-design/icons';
import { config as apiConfig, selectedProfile } from '../../config/config';
import GridTextItem from 'components/statosfera/common/GridTextItem';
import PaginationData from 'model/dto/PaginationData';
import ScrollX from 'components/ScrollX';
import ReactTable from 'components/statosfera/table/ReactTable';

const ShowClientEmailLogs = ({ model, clientId, onCancel, onSaved }) => {
    const theme = useTheme();
    const context = useAuth();
    const dispatch = useDispatch();
    const [t, i18n] = useTranslation();
    const [loaded, setLoaded] = useState(false);
    const [filter, setFilter] = useState(new PaginationData(0, 50, "desc", "timestamp", null));
    const [eventData, setEventData] = useState(null);

    const columns = useMemo(
      () => [
        {
          Header: t('id'),
          accessor: 'id',
          disableSortBy: true
        },
        {
          Header: t('event'),
          accessor: 'event',
          disableSortBy: true
        },
        {
          Header: t('type'),
          accessor: 'type',
          disableSortBy: true
        },
        {
          Header: t('date'),
          accessor: 'timestamp'
        }
      ]);

    useEffect(() => {
        setLoaded(false);
        if(!eventData) {
          model.fetchClientEmailLogs(dispatch, clientId, filter).unwrap().then(res => {
            setLoaded(true);
            if(res.success && res.data?.items) {
              setEventData(res.data);
            }
          });
        }
      }, [eventData, dispatch, clientId, filter]);


    const handlePageChange = (data) => {
      filter.page = data;
      setFilter(PaginationData.from(filter));
    }

    const handlePageSizeChange = (data) => {
      filter.limit = data;
      setFilter(PaginationData.from(filter));
    }
      let items = [];
      eventData?.items.forEach(i => {
        items.push({
          id: i.id,
          event: i.event,
          type: model.dataOrEmpty(i.type),
          timestamp: model.formatShortDate(i.timestamp),
        });
      });
      const sortBy = { id: 'timestamp', desc: true };
  
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DialogTitle>{t('client_email_logs')}</DialogTitle>
            <Divider />
            <DialogContent sx={{ p: 2.5 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  {eventData && 
                      <ScrollX>
                        <ReactTable
                          columns={columns}
                          data={items}
                          page={filter.page}
                          pageSize={filter.limit}
                          sortBy={sortBy}
                          search={''}
                          rowCountTotal={eventData?.numOfItems} 
                          getHeaderProps={(column) => column.getSortByToggleProps()}
                          handlePageChange={handlePageChange} 
                          handlePageSizeChange={handlePageSizeChange}
                          handleSort={null}
                          handleSearch={null}
                          topSpacing={0} />
                      </ScrollX>
                  }
                </Grid>
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 2.5 }}>
              <Grid container justifyContent="space-between" alignItems="center">
                <Grid item></Grid>
                <Grid item>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Button color="primary" onClick={onCancel}>
                      {t('close')}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </DialogActions>
  
        </LocalizationProvider>
    );
  };
  
  export default ShowClientEmailLogs;